<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Edit Money Line & account</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form v-if="moneylinedata.account != 'PROSPECT'">
                    <div class="form-row">
                        <div class="col-md-6">
                            <label for="accountno required">IMS Cash Available</label>
                            <div class="input-group mb-3">
                                <input type="number" class="form-control" id="accountno" v-model.number="moneylinedata.ims" >
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="accountno">Cash Only Available To TradeHist</label>
                            <div class="input-group mb-3">
                                <input type="number" class="form-control" id="cash" v-model.number="moneylinedata.cashOnlyAvailableToTradeHist" >
                                
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <!-- <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p> -->
                    <div class="modal-footer bid">
                        <!-- <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button> -->
                        <button type="button" class="btn btn-primary" @click="update()">UPDATE MONEY LINE</button>
                    </div>
              </form>
              <form v-if="accountData">
                <div class="form-row">
                    <div class="col-md-6">
                        <label for="accountno required">Account No *</label>
                        <div class="input-group mb-3">
                            <input :disabled="true" type="text" class="form-control" id="accountno" placeholder="Enter Account No" v-model="accountData.account">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="accountno">Is Margin</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.isMargin" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6" >
                        <label for="accountno">PMP</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.pmp" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="accountno">FBSI Short Name</label>
                        <div class="input-group mb-3">
                            <input  type="text" class="form-control" id="accountno" placeholder="FBSI Short Name" v-model="accountData.fbsiShortName">
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <label for="accountno">Note</label><br>
                        <label for="accountno">Last updated on : <span class="text-info">{{accountData.noteEditedDate ? moment(accountData.noteEditedDate).format('MM/DD/YYYY h:mm:ss a') : ''}}</span></label>
                        <div class="input-group mb-3">
                            <textarea  class="form-control" v-model="accountData.note" rows="3" maxlength="750"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <label for="accountno"></label>
                        <div class="input-group mb-3 is-margin">
                            <input type="checkbox" class="form-check-input" v-model="accountData.export">
                            <label class="form-check-label" for="inlineCheckbox1">Active Account</label>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <label for="accountno">Maturity</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.maturity" >
                                <option value="Short">Short</option>
                                <option value="Medium">Medium</option>
                                <option value="Long">Long</option>
                                <option value="All">All</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <label for="accountno">Spread</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model.number="accountData.spread" >
                                <option value="0.5">0.5</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <label for="accountno">Contact</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.contact" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <label for="accountno">EOD</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.eod" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    
                </div>    
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button type="button" class="btn btn-primary" @click="updateAccount()">UPDATE ACCOUNT</button>
                </div>
            </form>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'moneyLineEditmodal',
        components :{
            
        },
        props: ['moneylinedata'],
        data() {
            return {
                loading : false,
                errors: [],
                accountData : null
            };
        },
        methods: { 
            getAccountData(){
                this.loading = true;
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .get(config.baseUrlBidSide + "/account/"+this.moneylinedata.accountId, auth)
                    .then((result) => {
                        this.loading = false;   
                        if(result.data.isMargin === null || result.data.isMargin === ""){
                            result.data.isMargin = "N/A";
                        }else{
                            result.data.isMargin ? result.data.isMargin = "YES" : result.data.isMargin = "NO"
                        }
                        if(result.data.pmp === null || result.data.pmp === "" ){
                            result.data.pmp = "N/A";
                        }else{
                            result.data.pmp ? result.data.pmp = "YES" : result.data.pmp = "NO"
                        } 
                        if(result.data.contact === null){
                                result.data.contact = "N/A"
                        }else{
                                result.data.contact ? result.data.contact = "YES" : result.data.contact = "NO"
                        }
                        if(result.data.eod === null){
                                result.data.eod = "N/A"
                        }else{
                                result.data.eod ? result.data.eod = "YES" : result.data.eod = "NO"
                        }
                        delete result.data.primaryRep;
                        delete result.data.secondaryRep;        
                        this.accountData = result.data;   

                    })
                    .catch(() => {
                        this.loading = false;              
                    });
            },  
            updateAccount(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = { ...this.accountData};
                    if(addData.pmp == 'YES'){
                        addData.pmp = true
                    }else{
                        addData.pmp = false
                    }
                    if(addData.isMargin  == 'YES'){
                        addData.isMargin  = true
                    }else{
                        addData.isMargin  = false
                    }
                    if(addData.contact  == 'YES'){
                        addData.contact  = true
                    }else{
                        addData.contact  = false
                    }
                    if(addData.eod  == 'YES'){
                        addData.eod  = true
                    }else{
                        addData.eod  = false
                    }
                    delete addData.accountType;
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/account?cognitoSub="+authService.getUser().cognitoSub, addData, auth)
                    .then(() => {
                        this.loading = false;  
                        this.$alert("Successfully Updated","","success");

                        // this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            update(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    let addData = {"cashOnlyAvailableToTradeHist":this.moneylinedata.cashOnlyAvailableToTradeHist,"id":this.moneylinedata.id,"ims":this.moneylinedata.ims};
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/money-line/update", addData, auth)
                    .then(() => {
                        this.loading = false;  
                        this.$alert("Successfully Updated","","success");
                        // this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkForm(){
                this.errors = [];
                //if (!this.accountData.customerLastName) {
                //    this.errors.push("Customer last name is required.");
                //    return false;
                //}
                // if (!this.customerData.spread) {
                //     this.errors.push("Spread is required.");
                //     return false;
                // }
                return true
            }

        },
        created(){
            this.getAccountData();
            //console.log(this.moneylinedata)
        }
    };
    </script>
    <style>
    .modal .form-control{
        height: auto;
    }
    .is-margin{
        margin: 37px;
    }
    </style>